import _ from 'lodash/fp'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import gql from 'graphql-tag'

import * as JobsReducer from '../../reducers/events/jobs'
import apolloClient from '../../apollo'

const jobsQuery = gql`
  query jobs($clubId: Int, $guideId: Int, $userId: Int, $after: DateTime, $before: DateTime) {
    jobs(clubId: $clubId, guideId: $guideId, userId: $userId, after: $after, before: $before) {
      userId
      guideId
      clubId
      event
      message
      requestId
      data
      createdAt
    }
  }
`

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

function * getJobsEffect (body) {
  try {
    const result = yield call(apolloClient.query, { query: jobsQuery, variables: body, fetchPolicy: 'network-only' })
    return _.get('data.jobs', result) || []
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

function * getJobsFlow ({ payload }) {
  console.log('getJobsFlow', payload)
  const result = yield call(getJobsEffect, payload)
  if (result.error) {
    yield put(JobsReducer.actions.getJobsFailure(result.error))
  } else {
    yield put(JobsReducer.actions.getJobsSuccess(result))
  }
}

export default function * () {
  return yield all([
    takeLatest(JobsReducer.types.GET_JOBS, getJobsFlow)
  ])
}
